import React, { useMemo } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { rewriteHtmlImageUrls } from "utils/rewriteHtmlImageUrls";

const DEFAULT_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    ["blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link", "image"],
    ["clean"],
  ],
};

const DEFAULT_FORMATS = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "code-block",
  "list",
  "bullet",
  "align",
  "link",
  "image",
];

/** Avoid Quill rendering the literal string "null" / "undefined". */
const toEditorHtml = (value) => {
  if (value == null) return "";
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  if (trimmed === "" || trimmed === "null" || trimmed === "undefined") {
    return "";
  }
  return rewriteHtmlImageUrls(value);
};

/**
 * Shared rich-text editor for descriptions / email bodies.
 * Rewrites relative /assets img URLs so images load on the dashboard origin.
 */
const RichTextEditor = ({
  value,
  onChange,
  placeholder = "",
  className = "",
  modules = DEFAULT_MODULES,
  formats = DEFAULT_FORMATS,
  style,
}) => {
  const displayValue = useMemo(() => toEditorHtml(value), [value]);

  const handleChange = (content, _delta, source) => {
    if (typeof onChange !== "function") return;
    if (source === "silent") return;
    const next =
      !content ||
      content === "null" ||
      content === "<p><br></p>" ||
      content === "<p>null</p>"
        ? ""
        : content;
    onChange(next);
  };

  return (
    <div className={`rich-text-editor ${className}`}>
      <ReactQuill
        theme="snow"
        value={displayValue}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        style={{
          minHeight: 160,
          ...style,
        }}
      />
    </div>
  );
};

export default RichTextEditor;
